module.exports = __webpack_public_path__ + "img/awards-2.4650b42c.jpg";